import { Box, Button, Stack, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

interface ReportHeaderProps {
  loading: boolean;
  onRefresh: () => void;
  onExport: () => void;
}

const ReportHeader = ({ loading, onRefresh, onExport }: ReportHeaderProps) => {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", sm: "center" }}
      spacing={2}
      mb={2.5}
      sx={{ pb: 2.5, borderBottom: "1px solid", borderColor: "divider" }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box sx={{ width: 46, height: 46, display: "grid", placeItems: "center", borderRadius: 2, bgcolor: "primary.50", color: "primary.main" }}>
          <AssessmentOutlinedIcon />
        </Box>
        <Stack spacing={0.35}>
          <Typography variant="h4" fontWeight={800}>Reports</Typography>
          <Typography color="text.secondary" variant="body2">
            Consolidated spare parts, inventory, procurement, maintenance, and supplier reporting.
          </Typography>
          <Typography color="text.secondary" variant="caption">Home&nbsp;&nbsp; / &nbsp;&nbsp;Reports&nbsp;&nbsp; / &nbsp;&nbsp;Warehouse Reports</Typography>
        </Stack>
      </Stack>

      <Stack direction="row" spacing={1} sx={{ width: { xs: "100%", sm: "auto" } }}>
        <Button variant="outlined" startIcon={<RefreshIcon />} disabled={loading} onClick={onRefresh} sx={{ flex: { xs: 1, sm: "initial" } }}>
          Refresh
        </Button>
        <Button variant="contained" startIcon={<DownloadIcon />} onClick={onExport} sx={{ flex: { xs: 1, sm: "initial" } }}>
          Export
        </Button>
      </Stack>
    </Stack>
  );
};

export default ReportHeader;
